<template>
  <div>
    <h1>Портфолио</h1>
    <white-bg :style="{'min-height': specializations ? 'auto' : '500px'}" padding="25px 30px">
      <preload-content :loading="!specializations" :min-height="specializations ? 'auto' : '500px'">
        <template v-if="specializations">
          <template v-if="specializations.length">
            <h3>Порфтолио</h3>
            <div :key="idx" v-for="(specialization, idx) in specializations">
              <flex justify="between" align="center" mb="15px">
                <h4>{{ specialization.name }}</h4>
                <label :for="`input_${idx}`" v-if="isMobile" class="add__work-button">
                  <img src="../../../assets/images/icons/plus.svg" alt="">
                  <span>Добавить</span>
                </label>
                <button class="show_hide_btn" @click="specialization.show = !specialization.show" v-else>
                  <span>{{ specialization.show ? 'Свернуть' : 'Развернуть' }}</span>
                  <img
                      src="../../../assets/images/icons/chevron-down.svg"
                      alt=""
                      :class="{arrow_turn_over: specialization.show}"
                  >
                </button>
              </flex>
              <transition name="fade">
                <row margin="0 -10px" v-if="specialization.show" mobileOneRow>
                  <grid-item xl="2d4" mb="20px" padding="0 10px" mobilePaddingNone>
                    <label :for="`input_${idx}`" class="add__work">
                      <input type="file" :id="`input_${idx}`" @change="upload($event, specialization.id)">
                      <img src="../../../assets/images/icons/camera.svg" alt="">
                      <span>Загрузить работу</span>
                    </label>
                  </grid-item>
                  <template v-if="portfolio[specialization.id]">
                    <grid-item xl="2d4" :key="idx" v-for="(item, idx) in portfolio[specialization.id]" mb="20px">
                      <div class="portfolio__item" @click="portfolioItemClick(item.id)">
                        <img :src="item.path" style="height: 100%; object-fit: cover"/>
                        <div class="close" @click="del(item.id)"></div>
                      </div>
                    </grid-item>
                  </template>
                </row>
              </transition>
            </div>
          </template>
          <div v-else>
            <h1 style="display: flex;justify-content: center;align-items: center;height: 420px">Список специализаций
              пуст</h1>
          </div>
        </template>
        <CoolLightBox
          :items="portfolioItems"
          :index="selectedPortfolioIndex"
          @close="selectedPortfolioIndex = null">
        </CoolLightBox>
      </preload-content>
    </white-bg>
  </div>
</template>

<script>
import preloadContent from '../../../components/ui/preload-content'
import WhiteBg from '../../../components/ui/white-bg'
import Row from '../../../components/grid/Row'
import GridItem from '../../../components/grid/GridItem'
import Flex from '../../../components/ui/flex'

export default {
  name: 'Portfolio',
  components: {Flex, WhiteBg, GridItem, Row, preloadContent},
  data() {
    return {
      specializations: null,
      portfolio: {},
      selectedPortfolioIndex: null
    }
  },
  mounted() {
    this.loadPortfolio()
    this.loadSpecializations()
    setTimeout(() => {
      console.log('this.specializations', this.specializations)
      console.log('this.portfolio', this.portfolio)
    }, 500)
  },
  methods: {
    appendPortfolio(val) {
      if (!this.portfolio[val.specialization_id]) this.$set(this.portfolio, val.specialization_id, [])
      this.portfolio[val.specialization_id].unshift(val)
    },
    loadSpecializations() {
      return this.$api.master.specialization.list().then(({data}) => {
        this.specializations = data
        this.specializations.map((val, index) => this.$set(this.specializations[index], 'show', true))
      })
    },
    loadPortfolio() {
      return this.$api.master.portfolio.cabinetList().then(({data}) => data.map((val) => this.appendPortfolio(val)))
    },
    upload(event, specialization) {
      let image = event.target.files[0]
      if (!image.type.match('image.*')) return this.$toast.error('Формат изображения не поддерживаеться')
      return this.$api.master.portfolio.create({
        specialization_id: specialization,
        path: image
      }).then(({data}) => this.appendPortfolio(data))
    },
    del(id) {
      this.$api.master.portfolio.destroy(id)
          .then(({data}) => {
            this.portfolio[data.specialization_id] = this.portfolio[data.specialization_id].filter(item => item.id !== data.id)
          })
          .catch(() => this.$toast.error('Упс...Не удалось удалить. Попробуйте еще раз!'))
    },
    portfolioItemClick(id) {
      Object.values(this.portfolio).forEach(portfolioArray => {
        portfolioArray.forEach(portfolioItem => {
          if (portfolioItem.id === id) {
            this.selectedPortfolioIndex = this.portfolioItems.findIndex(item => item === portfolioItem.path)
          }
        })
      })
    }
  },
  computed: {
    isMobile() {
      return document.documentElement.clientWidth < 1170
    },
    portfolioItems() {
      const items = []
      Object.values(this.portfolio).forEach(portfolioArray => {
        portfolioArray.forEach(portfolioItem => {
          items.push(portfolioItem.path)
        })
      })
      return items
    }
  }
}
</script>

<style scoped lang="scss">
h4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
  font-family: "Open Sans", sans-serif;
}

.add__work {
  background: #FAFAFA;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  display: block;
  height: 100%;
  text-align: center;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;

  img {
    display: block;
    margin: 78px auto 40px auto;
  }

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
  }
}

.portfolio__item {
  position: relative;
  height: 280px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  & .close {
    content: '';
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 25px;
    height: 25px;
    background: url(../../../assets/images/icons/closew.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 90%;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }

  &:hover .close {
    opacity: 1;
  }
}

.show_hide_btn {
  font-family: "Open Sans", sans-serif;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: #B9765B;

  .arrow_turn_over {
    transform: rotate(180deg);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

.add__work-button {
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
  }

  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #B9765B;
  }
}

@media screen and (max-width: 1170px) {
  .add__work {
    position: absolute;
    z-index: -1;
  }
  .portfolio__item {
    width: 240px;
  }
}

h1 {
  display: none;
}

@media screen and (max-width: 991px) {
  h3 {
    display: none;
  }

  h1 {
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-bottom: 15px;
    margin-top: 0;
    padding-top: 0;
  }
  .whiteBg {
    padding: 15px !important;
    margin: 0 -15px !important;
  }
}

@media screen and (max-width: 480px) {
  h4 {
    font-size: 16px;
  }
  .add__work-button span {
    font-size: 14px;
  }
}
</style>
